export const intelligentStatus = {
    understanding: 'understanding',
    retrieving: 'retrieving',
    specificcontent: 'specificcontent'
};
